import React from "react"
import classNames from "classnames"
import { useParams } from "react-router-dom"
import MetabaseChartMolecule from "views/molecules/canvases/charts/analytics/MetabaseChartMolecule"
import { useAppContext } from "components/AppContext"

const WorkplaceExploreChartOrganism = () => {
  const { pillarId: urlPillarId } = useParams()
  const { envScore } = useAppContext()

  const dashboardAlias = envScore?.has_all_workplace_equipment_leased
    ? "dashboard_workplace_explore_leased"
    : "dashboard_workplace_explore"

  return (
    <div className="Verdikt-Score">
      <div className={classNames(urlPillarId, "page-frame")}>
        <div className={classNames("page")}>
          <div
            className={classNames(
              urlPillarId,
              "widget",
              "chart",
              "transparent-widget"
            )}
          >
            <MetabaseChartMolecule verdikt_alias={dashboardAlias} />
          </div>
        </div>
      </div>
    </div>
  )
}

export default WorkplaceExploreChartOrganism
